function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Public RedSquare capabilities for modules which consume tweets and threads.
 *
 * This adapter deliberately delegates storage, composition, rendering and
 * propagation to RedSquare. Consumers never need to import RedSquare classes.
 */
var RedSquareApi = /*#__PURE__*/function () {
  function RedSquareApi(app, mod) {
    _classCallCheck(this, RedSquareApi);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(RedSquareApi, [{
    key: "registerPeer",
    value: function registerPeer(peer) {
      if (!peer || typeof this.mod.registerPeer !== 'function') {
        return false;
      }
      this.mod.registerPeer(peer);
      return true;
    }
  }, {
    key: "composeRoot",
    value: function composeRoot() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$text = _ref.text,
        text = _ref$text === void 0 ? '' : _ref$text,
        _ref$prompt = _ref.prompt,
        prompt = _ref$prompt === void 0 ? '' : _ref$prompt;
      return this.openComposer({
        mode: 'post',
        text: text,
        prompt: prompt
      });
    }
  }, {
    key: "composeReply",
    value: function () {
      var _composeReply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _ref2,
          root_tx_sig,
          parent_tx_sig,
          _ref2$text,
          text,
          _ref2$prompt,
          prompt,
          _ref2$publishImmediat,
          publishImmediately,
          context,
          parent,
          body,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, root_tx_sig = _ref2.root_tx_sig, parent_tx_sig = _ref2.parent_tx_sig, _ref2$text = _ref2.text, text = _ref2$text === void 0 ? '' : _ref2$text, _ref2$prompt = _ref2.prompt, prompt = _ref2$prompt === void 0 ? '' : _ref2$prompt, _ref2$publishImmediat = _ref2.publishImmediately, publishImmediately = _ref2$publishImmediat === void 0 ? false : _ref2$publishImmediat;
              _context.n = 1;
              return this.resolveTweet({
                root_tx_sig: root_tx_sig,
                source_tx_sig: parent_tx_sig
              });
            case 1:
              context = _context.v;
              parent = this.mod.getTweet(context.source_tx_sig);
              if (parent) {
                _context.n = 2;
                break;
              }
              throw new Error('RedSquare reply parent is unavailable');
            case 2:
              if (!publishImmediately) {
                _context.n = 4;
                break;
              }
              body = String(text || '').trim();
              if (body) {
                _context.n = 3;
                break;
              }
              throw new Error('A reply must contain text');
            case 3:
              return _context.a(2, this.publishReply(parent, context.root_tx_sig, body));
            case 4:
              return _context.a(2, this.openComposer({
                mode: 'reply',
                reply_to: parent,
                text: text,
                prompt: prompt
              }));
          }
        }, _callee, this);
      }));
      function composeReply() {
        return _composeReply.apply(this, arguments);
      }
      return composeReply;
    }()
  }, {
    key: "resolveTweet",
    value: function () {
      var _resolveTweet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _source$tx;
        var _ref3,
          root_tx_sig,
          source_tx_sig,
          requestedRoot,
          requestedSource,
          source,
          isRoot,
          hasExpectedThread,
          root,
          _args2 = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _ref3 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, root_tx_sig = _ref3.root_tx_sig, source_tx_sig = _ref3.source_tx_sig;
              requestedRoot = String(root_tx_sig || '');
              requestedSource = String(source_tx_sig || '');
              if (!(!requestedRoot || !requestedSource)) {
                _context2.n = 1;
                break;
              }
              throw new Error('RedSquare root and source transaction signatures are required');
            case 1:
              _context2.n = 2;
              return this.loadTweet(requestedSource);
            case 2:
              source = _context2.v;
              if (source) {
                _context2.n = 3;
                break;
              }
              throw new Error('RedSquare source transaction was not found');
            case 3:
              isRoot = source.signature === requestedRoot;
              hasExpectedThread = String(source.thread_id || source.signature) === requestedRoot;
              _t = !isRoot;
              if (!_t) {
                _context2.n = 6;
                break;
              }
              _t2 = !hasExpectedThread;
              if (_t2) {
                _context2.n = 5;
                break;
              }
              _context2.n = 4;
              return this.hasAncestor(source, requestedRoot);
            case 4:
              _t2 = !_context2.v;
            case 5:
              _t = _t2;
            case 6:
              if (!_t) {
                _context2.n = 7;
                break;
              }
              throw new Error('RedSquare source transaction is not in the supplied thread');
            case 7:
              _context2.n = 8;
              return this.loadTweet(requestedRoot);
            case 8:
              root = _context2.v;
              if (root) {
                _context2.n = 9;
                break;
              }
              throw new Error('RedSquare root transaction was not found');
            case 9:
              return _context2.a(2, {
                root_tx_sig: requestedRoot,
                source_tx_sig: source.signature,
                reporter_publickey: source.publicKey || ((_source$tx = source.tx) === null || _source$tx === void 0 || (_source$tx = _source$tx.from) === null || _source$tx === void 0 || (_source$tx = _source$tx[0]) === null || _source$tx === void 0 ? void 0 : _source$tx.publicKey) || '',
                transaction: source.tx
              });
          }
        }, _callee2, this);
      }));
      function resolveTweet() {
        return _resolveTweet.apply(this, arguments);
      }
      return resolveTweet;
    }()
  }, {
    key: "resolveReplyRoot",
    value: function () {
      var _resolveReplyRoot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(transaction) {
        var _transaction$returnMe;
        var msg, data, signature, tweet, parent;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              msg = (transaction === null || transaction === void 0 || (_transaction$returnMe = transaction.returnMessage) === null || _transaction$returnMe === void 0 ? void 0 : _transaction$returnMe.call(transaction)) || (transaction === null || transaction === void 0 ? void 0 : transaction.msg) || {};
              data = msg.data || {};
              if (!data.thread_id) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, String(data.thread_id));
            case 1:
              signature = String((transaction === null || transaction === void 0 ? void 0 : transaction.signature) || '');
              if (!signature) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return this.loadTweet(signature);
            case 2:
              tweet = _context3.v;
              if (!tweet) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, this.resolveTweetRoot(tweet));
            case 3:
              if (!data.parent_id) {
                _context3.n = 5;
                break;
              }
              _context3.n = 4;
              return this.loadTweet(data.parent_id);
            case 4:
              parent = _context3.v;
              if (!parent) {
                _context3.n = 5;
                break;
              }
              return _context3.a(2, this.resolveTweetRoot(parent));
            case 5:
              return _context3.a(2, '');
          }
        }, _callee3, this);
      }));
      function resolveReplyRoot(_x) {
        return _resolveReplyRoot.apply(this, arguments);
      }
      return resolveReplyRoot;
    }()
  }, {
    key: "renderThread",
    value: function () {
      var _renderThread = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(container) {
        var _this = this;
        var _ref4,
          root_tx_sig,
          source_tx_sig,
          _ref4$reply,
          reply,
          context,
          host,
          selector,
          source,
          _this$mod$tweets_chil,
          children,
          _iterator,
          _step,
          child,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _ref4 = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {}, root_tx_sig = _ref4.root_tx_sig, source_tx_sig = _ref4.source_tx_sig, _ref4$reply = _ref4.reply, reply = _ref4$reply === void 0 ? true : _ref4$reply;
              this.ensureTweetStyles();
              _context4.n = 1;
              return this.resolveTweet({
                root_tx_sig: root_tx_sig,
                source_tx_sig: source_tx_sig
              });
            case 1:
              context = _context4.v;
              _context4.n = 2;
              return this.mod.loadTweetThread(context.source_tx_sig);
            case 2:
              host = typeof container === 'string' ? document.querySelector(container) : container;
              if (host) {
                _context4.n = 3;
                break;
              }
              throw new Error('RedSquare thread container was not found');
            case 3:
              selector = this.ensureSelector(host);
              source = this.mod.getTweet(context.source_tx_sig);
              if (source) {
                _context4.n = 4;
                break;
              }
              throw new Error('RedSquare source transaction was not found');
            case 4:
              host.innerHTML = '';
              source.render(selector, {
                focused: true,
                presentation: 'focused'
              });
              if (reply) {
                children = (((_this$mod$tweets_chil = this.mod.tweets_children) === null || _this$mod$tweets_chil === void 0 ? void 0 : _this$mod$tweets_chil[source.signature]) || []).map(function (signature) {
                  return _this.mod.getTweet(signature);
                }).filter(Boolean).sort(function (a, b) {
                  return Number(a.created_at || 0) - Number(b.created_at || 0);
                });
                _iterator = _createForOfIteratorHelper(children);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    child = _step.value;
                    child.render(selector, {
                      reply: true,
                      presentation: 'reply'
                    });
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              this.attachThreadEvents(host);
              return _context4.a(2, function () {
                if (host.isConnected) {
                  host.innerHTML = '';
                }
              });
          }
        }, _callee4, this);
      }));
      function renderThread(_x2) {
        return _renderThread.apply(this, arguments);
      }
      return renderThread;
    }()
  }, {
    key: "openThread",
    value: function () {
      var _openThread = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _ref5,
          root_tx_sig,
          source_tx_sig,
          context,
          path,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _ref5 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, root_tx_sig = _ref5.root_tx_sig, source_tx_sig = _ref5.source_tx_sig;
              _context5.n = 1;
              return this.resolveTweet({
                root_tx_sig: root_tx_sig,
                source_tx_sig: source_tx_sig
              });
            case 1:
              context = _context5.v;
              if (!(this.mod.browser_active && this.mod.manager)) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return this.mod.manager.renderThread(context.source_tx_sig);
            case 2:
              return _context5.a(2, context.source_tx_sig);
            case 3:
              path = "/".concat(encodeURI(this.mod.returnSlug()), "/tweet/").concat(encodeURIComponent(context.source_tx_sig));
              if (typeof navigateWindow === 'function') {
                navigateWindow(path);
              } else if (typeof window !== 'undefined') {
                window.location.assign(path);
              }
              return _context5.a(2, context.source_tx_sig);
          }
        }, _callee5, this);
      }));
      function openThread() {
        return _openThread.apply(this, arguments);
      }
      return openThread;
    }()
  }, {
    key: "openComposer",
    value: function openComposer(options) {
      var _this$mod$compose_ove,
        _this2 = this;
      if (!((_this$mod$compose_ove = this.mod.compose_overlay) !== null && _this$mod$compose_ove !== void 0 && _this$mod$compose_ove.open)) {
        throw new Error('RedSquare composer is unavailable');
      }
      return new Promise(function (resolve) {
        _this2.mod.compose_overlay.open(_objectSpread(_objectSpread({}, options), {}, {
          onComplete: resolve
        }));
      });
    }
  }, {
    key: "publishReply",
    value: function () {
      var _publishReply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(parent, rootTxSig, text) {
        var keys, tx, tweet, _this$mod$manager;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              keys = this.collectRecipientKeys(parent);
              _context6.n = 1;
              return this.mod.createTweetTransaction({
                text: text,
                parent_id: parent.signature,
                thread_id: rootTxSig
              }, keys);
            case 1:
              tx = _context6.v;
              _context6.n = 2;
              return tx.sign();
            case 2:
              _context6.n = 3;
              return this.app.network.propagateTransaction(tx);
            case 3:
              _context6.n = 4;
              return this.mod.receiveTweetTransaction(tx);
            case 4:
              tweet = _context6.v;
              if (tweet) {
                (_this$mod$manager = this.mod.manager) === null || _this$mod$manager === void 0 || _this$mod$manager.onTweetPosted(tweet);
              }
              return _context6.a(2, tx);
          }
        }, _callee6, this);
      }));
      function publishReply(_x3, _x4, _x5) {
        return _publishReply.apply(this, arguments);
      }
      return publishReply;
    }()
  }, {
    key: "collectRecipientKeys",
    value: function collectRecipientKeys(tweet) {
      var _tweet$tx;
      var keys = [];
      var add = function add(publicKey) {
        if (publicKey && !keys.includes(publicKey)) {
          keys.push(publicKey);
        }
      };
      add(tweet === null || tweet === void 0 ? void 0 : tweet.publicKey);
      var _iterator2 = _createForOfIteratorHelper((tweet === null || tweet === void 0 || (_tweet$tx = tweet.tx) === null || _tweet$tx === void 0 ? void 0 : _tweet$tx.to) || []),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var slip = _step2.value;
          add(slip === null || slip === void 0 ? void 0 : slip.publicKey);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return keys;
    }
  }, {
    key: "loadTweet",
    value: function () {
      var _loadTweet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(signature) {
        var cached, result;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              cached = this.mod.getTweet(signature);
              if (!cached) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, cached);
            case 1:
              _context7.n = 2;
              return this.mod.loadTweetThread(signature);
            case 2:
              result = _context7.v;
              return _context7.a(2, (result === null || result === void 0 ? void 0 : result.status) === 'loaded' ? result.tweet : null);
          }
        }, _callee7, this);
      }));
      function loadTweet(_x6) {
        return _loadTweet.apply(this, arguments);
      }
      return loadTweet;
    }()
  }, {
    key: "resolveTweetRoot",
    value: function () {
      var _resolveTweetRoot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(tweet) {
        var _current2;
        var current, visited, _current, parent;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!tweet.thread_id) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, String(tweet.thread_id));
            case 1:
              current = tweet;
              visited = new Set();
            case 2:
              if (!((_current = current) !== null && _current !== void 0 && _current.parent_id && !visited.has(current.signature))) {
                _context8.n = 5;
                break;
              }
              visited.add(current.signature);
              _context8.n = 3;
              return this.loadTweet(current.parent_id);
            case 3:
              parent = _context8.v;
              if (parent) {
                _context8.n = 4;
                break;
              }
              return _context8.a(3, 5);
            case 4:
              current = parent;
              _context8.n = 2;
              break;
            case 5:
              return _context8.a(2, String(((_current2 = current) === null || _current2 === void 0 ? void 0 : _current2.signature) || ''));
          }
        }, _callee8, this);
      }));
      function resolveTweetRoot(_x7) {
        return _resolveTweetRoot.apply(this, arguments);
      }
      return resolveTweetRoot;
    }()
  }, {
    key: "hasAncestor",
    value: function () {
      var _hasAncestor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(tweet, expectedSignature) {
        var _current4;
        var current, visited, _current3;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              current = tweet;
              visited = new Set();
            case 1:
              if (!((_current3 = current) !== null && _current3 !== void 0 && _current3.parent_id && !visited.has(current.signature))) {
                _context9.n = 4;
                break;
              }
              if (!(current.parent_id === expectedSignature)) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2, true);
            case 2:
              visited.add(current.signature);
              _context9.n = 3;
              return this.loadTweet(current.parent_id);
            case 3:
              current = _context9.v;
              _context9.n = 1;
              break;
            case 4:
              return _context9.a(2, ((_current4 = current) === null || _current4 === void 0 ? void 0 : _current4.signature) === expectedSignature);
          }
        }, _callee9, this);
      }));
      function hasAncestor(_x8, _x9) {
        return _hasAncestor.apply(this, arguments);
      }
      return hasAncestor;
    }()
  }, {
    key: "ensureSelector",
    value: function ensureSelector(host) {
      if (/^[A-Za-z][A-Za-z0-9_-]*$/.test(host.id || '')) {
        return "#".concat(host.id);
      }
      host.id = "redsquare-thread-".concat(Math.random().toString(36).slice(2));
      return "#".concat(host.id);
    }
  }, {
    key: "ensureTweetStyles",
    value: function ensureTweetStyles() {
      var _this$app$browser, _this$app$browser$add;
      (_this$app$browser = this.app.browser) === null || _this$app$browser === void 0 || (_this$app$browser$add = _this$app$browser.addStylesheet) === null || _this$app$browser$add === void 0 || _this$app$browser$add.call(_this$app$browser, '/redsquare/css/redsquare-tweet.css');
    }
  }, {
    key: "attachThreadEvents",
    value: function attachThreadEvents(host) {
      var manager = this.mod.manager;
      if (!manager) {
        return;
      }
      manager.attachTweetNavigation(host);
      manager.attachTweetImageViewer(host);
      manager.attachThreadContext(host);
      manager.attachTweetMenu(host);
      manager.attachTweetReply(host);
      manager.attachTweetLike(host);
      manager.attachTweetRetweet(host);
      manager.attachTweetShare(host);
    }
  }]);
}();
module.exports = RedSquareApi;